module.exports = __webpack_public_path__ + "img/17.c11d4129.png";